import { render, staticRenderFns } from "./TypeStatistics.vue?vue&type=template&id=4d860f72&scoped=true&"
import script from "./TypeStatistics.vue?vue&type=script&lang=js&"
export * from "./TypeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TypeStatistics.vue?vue&type=style&index=0&id=4d860f72&lang=less&scoped=true&"
import style1 from "./TypeStatistics.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d860f72",
  null
  
)

export default component.exports